document.addEventListener('DOMContentLoaded', (event) => {
/////////////////////////////////////////////////////////////////// PRODUCT PAGE - START ////////////////////////////////////////////////////////////////////////
    function preventVideoFocusWhenIsNoVisible() {
        const container = document.querySelector('slideshow-slides');
        if (!container) return;

        const slides = container.querySelectorAll('slideshow-slide');

        const updateTabIndex = (slide) => {
            const videoButton = slide.querySelector('.deferred-media__poster-button');
            if (!videoButton) return;

            const isHidden = slide.getAttribute('aria-hidden') === 'true';
            videoButton.setAttribute('tabindex', isHidden ? '-1' : '0');
        };

        const observerConfig = {
            attributes: true,
            attributeFilter: ['aria-hidden']
        };

        slides.forEach(slide => {
            updateTabIndex(slide);

            const observer = new MutationObserver((mutations) => {
                mutations.forEach((mutation) => {
                    if (mutation.attributeName === 'aria-hidden') {
                        updateTabIndex(mutation.target);
                    }
                });
            });

            observer.observe(slide, observerConfig);
        });
    }

    function fixSliderProductStoriesAccessibility() {
        const container = document.querySelector('tolstoy-stories');
        if (!container) return;

        // Observer for visual intersection
        const visibilityObserver = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
                const tile = entry.target;
                const isVisible = entry.isIntersecting;

                // Update accessibility attributes based on visibility
                tile.setAttribute('aria-hidden', !isVisible);
                tile.setAttribute('tabindex', isVisible ? '0' : '-1');
            });
        }, { 
            threshold: 0.4 
        });

        const applyAccessibility = () => {
            const title = container.querySelector('.tolstoy-stories-title');
            const sliderParent = container.querySelector('.tolstoy-stories-tiles-container');
            const prevBtn = container.querySelector('.tolstoy-stories-previous-button');
            const nextBtn = container.querySelector('.tolstoy-stories-next-button');
            const tiles = container.querySelectorAll('.tolstoy-stories-tile');

            if (tiles.length === 0 || !sliderParent) return false;

            if (title) {
                title.setAttribute('id', 'ADA-product-stories-title');
            }

            if (sliderParent) {
                sliderParent.removeAttribute('role');
                sliderParent.removeAttribute('aria-label');
                sliderParent.setAttribute('aria-labelledby', 'ADA-product-stories-title');
            }

            if (prevBtn) prevBtn.setAttribute('aria-label', 'Previous slide');
            if (nextBtn) nextBtn.setAttribute('aria-label', 'Next slide');

            // Start observing each tile
            tiles.forEach((tile, index) => {
                visibilityObserver.observe(tile);
                tile.setAttribute('aria-label', `Product story ${index + 1} of ${tiles.length}`);
            });
            
            return true;
        };

        // Initial attempt in case it's already loaded
        if (!applyAccessibility()) {
            const observer = new MutationObserver((mutations, obs) => {
                if (applyAccessibility()) {
                    obs.disconnect();
                }
            });

            observer.observe(container, {
                childList: true,
                subtree: true
            });
        }
    }

    function sliderAnnouncerForProductPage() {
        const sliderWrapper = document.querySelector('slideshow-container');
        const track = sliderWrapper?.querySelector('slideshow-slides');
        const slides = track?.querySelectorAll('slideshow-slide');
        const announcer = document.getElementById('product-slider-announcer');

        if (!sliderWrapper || !track || !slides || !announcer) return;

        // Use a WeakMap to track visibility status of each slide efficiently
        const visibleSlidesMap = new WeakMap();

        const updateUI = () => {
            // Find the index of the slide that is currently most visible
            const slideArray = Array.from(slides);
            const currentIndex = slideArray.findIndex(slide => visibleSlidesMap.get(slide)) + 1;
            
            const total = slides.length;
            
            if (currentIndex > 0) {
                const message = `Slide ${currentIndex} of ${total}`;
                if (announcer.textContent !== message) {
                    announcer.textContent = message;
                }
            }
        };

        const observerOptions = {
            root: track,
            threshold: 0.6 
        };

        const visibilityObserver = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                // Update the map with the current intersection state
                visibleSlidesMap.set(entry.target, entry.isIntersecting);
            });

            // Trigger UI update after processing all changes
            updateUI();
        }, observerOptions);

        slides.forEach(slide => visibilityObserver.observe(slide));

        // Accessibility focus management
        sliderWrapper.addEventListener('focusin', () => {
            announcer.setAttribute('aria-hidden', 'false');
            updateUI();
        });

        sliderWrapper.addEventListener('focusout', (event) => {
            if (!sliderWrapper.contains(event.relatedTarget)) {
                announcer.setAttribute('aria-hidden', 'true');
                announcer.textContent = "";
            }
        });
    }



    //////Excution zone
    preventVideoFocusWhenIsNoVisible();
    fixSliderProductStoriesAccessibility();
    sliderAnnouncerForProductPage();

/////////////////////////////////////////////////////////////////// PRODUCT PAGE - END ////////////////////////////////////////////////////////////////////////


/////////////////////////////////////////////////////////////////// COLLECTIONS PAGE - START ////////////////////////////////////////////////////////////////////////
    //Function to handle correctly keyboard events at SORT filters section
    function handleKeyboardEvent() {
        const triggerContainer = document.querySelector('sorting-filter-component');
        const container = document.querySelector('.sorting-filter__options');

        if (!container || !triggerContainer) return;
        

        function applyFix() {
            const options = container.querySelectorAll('.sorting-filter__option');
            
            options.forEach(element => {
                element.removeEventListener('keydown', handleOptionKeydown);
                element.addEventListener('keydown', handleOptionKeydown);
            });
        }

        function handleOptionKeydown(e) {
            if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault(); 
                const input = this.querySelector('input');
                if (input) {
                    input.click();
                }
            }
        }

        
        triggerContainer.addEventListener('click', () => {
            const openContainer = triggerContainer.querySelector('summary')
            const isOpen = openContainer.getAttribute('aria-expanded');

            if(isOpen === 'false')
            setTimeout(applyFix, 50);
        });

        triggerContainer.addEventListener('keydown', (e) => {
            const openContainer = triggerContainer.querySelector('summary')
            const isOpen = openContainer.getAttribute('aria-expanded');

            if ((e.key === 'Enter' || e.key === ' ') && isOpen === 'false') {
                triggerContainer.click();
            }
        });
    }

    //////Execution zone
    handleKeyboardEvent();

/////////////////////////////////////////////////////////////////// COLLECTIONS PAGE - START ////////////////////////////////////////////////////////////////////////

})